import "styles/signUpPage.less";
import { useEffect } from "react";

import { Row, Col, Grid, Layout } from "antd";
import signUpImage from "assets/images/home/sign-up-desktop.png";
import Header from "components/basic/Header/Header";
import SignUpForm from "components/basic/SignUpForm/SignUpForm";
import { scrollToTop } from "utils/common";

const { useBreakpoint } = Grid;

const SignUpPage = () => {
    useEffect(() => {
        scrollToTop();
    }, []);

    const screens = useBreakpoint();

    return (
        <Layout className="layout">
            <Header />
            <Row className="sign-up-page__row mAuto">
                <Col
                    className="sign-up-page__col--form"
                    xs={24}
                    md={12}
                >
                    <div className="sign-up-page__form">
                        <SignUpForm />
                    </div>

                </Col>

                {/* Only show the image on medium screens and up */}
                {screens.md && (
                    <Col
                        className="sign-up-page__col--image"
                        xs={0}
                        md={12}
                    >
                        <div className="sign-up-page__image-container">
                            <img
                                className="sign-up-page__image"
                                src={signUpImage}
                                alt="Sign Up Illustration"
                            />
                        </div>

                    </Col>
                )}
            </Row>
        </Layout>
    );
};

export default SignUpPage;
